import { getApiUrl, API_CONFIG } from '../config/api';

/**
 * Check invite email account type (requires valid brand signup/signin token).
 * @returns {Promise<{ accountType: string, authProviders: string[], hasFirebaseAuth: boolean, hasFirestoreProfile: boolean } | null>}
 */
export async function checkInviteEmailAccountType(email, token) {
  if (!email || !token) return null;

  try {
    const url = getApiUrl(API_CONFIG.ENDPOINTS.CHECK_INVITE_EMAIL);

    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email.trim(), token }),
    });

    if (!response.ok) return null;
    const data = await response.json();
    if (!data.success) return null;
    return data;
  } catch (err) {
    console.warn('Could not check invite email account type:', err);
    return null;
  }
}

export default { checkInviteEmailAccountType };
